import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=b58d8f84&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=b58d8f84&lang=scss&scoped=true&"
import style1 from "./CustomersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d8f84",
  null
  
)

export default component.exports